import {
  HttpErrorHandlerFn,
  isUnprocessableEntity,
  UnprocessableEntityHttpErrorResponse,
} from '@web/common';
import { inject } from '@angular/core';
import { UnprocessableEntityErrorCode } from '../types/unprocessable-entity-error-code';
import { UnprocessableEntityErrorMessageParameter } from '../enums/unprocessable-entity-error-message-parameter';
import { UnprocessableEntityErrorMessageProviderService } from '../providers/unprocessable-entity-error-message-provider.service';

/* prettier-ignore */
export const UnprocessableEntityErrorHandler: HttpErrorHandlerFn = (error) => {
  const provider = inject(UnprocessableEntityErrorMessageProviderService);

  if (isUnprocessableEntity(error)) {
    const response = UnprocessableEntityHttpErrorResponse.fromResponse<UnprocessableEntityErrorCode, UnprocessableEntityErrorMessageParameter>(error);

    return response.violations.map((violation) => {
      const { code, parameters } = violation;
      const params = Object.entries(parameters).reduce((result, [parameter, value]) => ({ ...result, ...{ [parameter]: value }}), {} as Record<UnprocessableEntityErrorMessageParameter, string>);

      try {
        return provider.message(code, params);
      } catch (e) {
        return `Nieznany kod błędu "${code}".`;
      }
    });
  }

  return null;
};
